import { atom, useAtom } from 'jotai'

import { ServerAsset } from '@sequencehq/api'

export const currentInspectorAttachmentAtom = atom<ServerAsset | null>(null)

export const useCurrentInspectorAsset = () => {
  const [currentInspectorAsset, setCurrentInspectorAsset] = useAtom(
    currentInspectorAttachmentAtom
  )

  return { currentInspectorAsset, setCurrentInspectorAsset }
}
